export default "__VITE_ASSET__afd6e1f2__"